import React from 'react';
import { useDispatch } from 'react-redux';
import SVG from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import classes from '../InCallParticipant.module.scss';
import { hooks } from '@lifesize/clients.sdk';
import handIcon from '@lifesize/ux-assets/vectors/svgIcons/hand.svg';
import Tooltip from 'components/Tooltip/Tooltip';
import { moderatorActions } from '@lifesize/nucleus';

interface Props {
  participant: any;
}

export const ParticipantRaisedHandButton = ({ participant }: Props) => {
  const userIsModerator = hooks.useIsCurrentUserModerator();
  const { handRaised, isSelf } = participant;
  const dispatch = useDispatch();

  const handleSelectRaisedHandClicked = (participantId) => {
    dispatch(moderatorActions.lowerParticipantHand(participantId));
  };

  if (!handRaised) return null;

  if (!!handRaised && userIsModerator && !isSelf) {
    return (
      <button className={classes.button} onClick={() => handleSelectRaisedHandClicked(participant?.participantId)}>
        <SVG src={handIcon} className={`${classes.buttonIcon} ${classes.raisedHandIcon}`} />
        <Tooltip
          fixPosition={true}
          location={'top'}
          overlapCarat={false}
          label={
            <FormattedMessage
              id="components.inCall.participantDrawer.tooltip.lowerHand"
              defaultMessage="Click to Lower Hand"
            />
          }
        />
      </button>
    );
  }
  return (
    <div className={`${classes.button} ${classes.noButton}`}>
      <SVG src={handIcon} className={`${classes.buttonIcon} ${classes.raisedHandIcon}`} />
    </div>
  );
};

export default ParticipantRaisedHandButton;
